export default {
    items: [
        {
            name: 'Dashboard',
            url: '/crm/home',
            icon: 'icon-speedometer',
            badge: {
                variant: 'primary',
                text: 'NEW'
            }
        },
        {
            name: 'Comenzi',
            url: '/crm/orders/confirmed',
            icon: 'fa fa-car',
        },
        {
            name: 'Expirari',
            url: '/crm/orders/expiring',
            icon: 'fa fa-calendar'
        },
        {
            name: 'Rate scadente',
            url: '/crm/orders/payments',
            icon: 'fa fa-money'
        },
        {
            name: 'Oferte salvate',
            url: '/crm/orders/request',
            icon: 'fa fa-address-card-o',
        },
        {
            name: 'Black list',
            url: '/crm/blacklist',
            icon: 'fa fa-file',
            restricted: ['admin'],
        },
        {
            name: 'Utilizatori',
            url: '/crm/users',
            icon: 'icon-people',
            restricted: ['admin']
        },
        {
            name: 'Setari',
            url: '/crm/home',
            icon: 'icon-settings',
            restricted: ['admin'],
            children: [
                //{
                //    name: 'Setari generale',
                //    url: '/crm/settings',
                //    icon: 'fa fa-gears',
                //    restricted: ['admin']
                //},
                {
                    name: 'Tipuri de polite',
                    url: '/crm/OrderType',
                    icon: 'fa fa-cubes',
                    restricted: ['admin']
                },
            ]
        },
    ]
}
